import { RegisterImplementationProps } from 'constants/types';
import SignInBase from '../SignInBase';
import InstructionsCheckbox from 'components/Input/InstructionsCheckboxInput';
import MainContainer from '../SignInMainContainer';
import LoaderButton from 'components/Button/LoaderButton';
import PasswordInput from 'components/Input/PasswordInput';
import { apiTokenInstructions, getProviderFormLabel } from '../utils';
import Input from 'components/Input/Input';

const SignInSesameApi = ({
  client,
  isLoading,
  onSubmit,
  provider,
  instructionsLink,
}: RegisterImplementationProps) => {
  const instructions = apiTokenInstructions(provider.displayName, client);

  return (
    <SignInBase
      formLabel={getProviderFormLabel(provider)}
      instructions={instructions}
      instructionsLink={instructionsLink}
      divider
      onSubmit={onSubmit}
      fieldNames={['instructionCheck', 'apiToken', 'domain']}
      render={({ instructionCheck, apiToken, domain }) => {
        return (
          <>
            <MainContainer useNewDesign>
              <InstructionsCheckbox
                checked={instructionCheck.value}
                onChange={(checked) => instructionCheck.onChange(checked)}
              />
              <Input
                value={domain.value}
                onChange={(event) => domain.onChange(event.target.value)}
                invalid={domain.invalid}
                label="Server Domain"
                id="domain"
                helperText="Example: api-eu1.sesametime.com"
              />
              <PasswordInput
                value={apiToken.value}
                onChange={(event) => apiToken.onChange(event.target.value)}
                invalid={apiToken.invalid}
                label="API Token"
                id="apiToken"
              />
            </MainContainer>
            <LoaderButton
              text="Connect"
              isLoading={isLoading}
              disabled={
                isLoading ||
                !instructionCheck.value ||
                !apiToken.value ||
                !domain.value
              }
              type="submit"
            />
          </>
        );
      }}
    />
  );
};

export default SignInSesameApi;
